import React from 'react';

interface Props extends React.HTMLAttributes<HTMLElement> {
    level: 1 | 2 | 3 | 4 | 5 | 6;
    children: React.ReactNode;
    bold?: boolean;
}

function Header(props: Props) {
    const { className, bold, ...otherProps } = props;
    const classNames = `${className || ''} header-${props.level} ${bold ? 'bold' : ''}`;

    return (
        <div className={classNames} {...otherProps}>
            {props.children}
        </div>
    );
}

export default Header;
